import {
  Component,
  inject,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TableModule } from '@openng/optimus-ui/table';

import { CommonModule } from '@angular/common';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { ButtonModule } from '@openng/optimus-ui/button';
import { InputTextModule } from '@openng/optimus-ui/inputtext';
import { GreyOverlayService } from '../../services/grey-overlay.service';
import { AccountInfoService } from '../../services/account-info.service';
import { ImportLegacyTemplateComponent } from '../template-components/common/import-legacy-template/import-legacy-template.component';

import { Subject } from 'rxjs';
import { RecipientComponent } from '../template-components/common/recipient/recipient.component';
import { AuditLogTableComponent } from '../audit-log-table/audit-log-table.component';

@Component({
    selector: 'app-settings',
    imports: [
        ReactiveFormsModule,
        TableModule,
        FormsModule,
        CommonModule,
        ButtonModule,
        InputTextModule,
        ImportLegacyTemplateComponent,
        RecipientComponent,
        NgbNavModule,
        AuditLogTableComponent
    ],
    templateUrl: './settings.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './settings.component.scss'
})
export class SettingsComponent implements OnInit, OnDestroy {
  private modalService = inject(NgbModal);

  active = 'recipients';

  @ViewChild('content') content!: TemplateRef<any>;
  private _destroy$ = new Subject<void>();

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  constructor(
    private greyOverlayService: GreyOverlayService,
    private accountInfoService: AccountInfoService
  ) {
  }

  openSettingsModal() {
    if (this.content) {
      this.modalService.open(this.content, {
        size: 'xl',
        backdrop: 'static',
      });
    }
  }

  closeFromChild(modal: any) {
    modal.close();
  }
}
